import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { orchestrator } from 'satcheljs';
export default orchestrator(deleteItemsStoreUpdate, function (actionMessage) {
    var itemContexts = actionMessage.itemContexts;
    var totalUnreadDeleted = 0;
    for (var _i = 0, itemContexts_1 = itemContexts; _i < itemContexts_1.length; _i++) {
        var itemContext = itemContexts_1[_i];
        if (!itemContext.isRead) {
            totalUnreadDeleted++;
        }
    }
    updateFolderCounts(-1 * totalUnreadDeleted /* unreadCount */, -1 * itemContexts.length /* totalCount */, actionMessage.parentFolderId /* folderId */, true /* isDeltaChange */);
});
//# sourceMappingURL=deleteItemsStoreUpdateOrchestrator.js.map